// page-activity.js
export default {
  data() {
    return {
      isTabVisible: true,
      isWindowFocused: true
    };
  },
  computed: {
    isPageActive() {
      return this.isTabVisible && this.isWindowFocused;
    }
  },
  mounted() {
    this.handleVisibilityChange = () => {
      this.isTabVisible = document.visibilityState === 'visible';
      this.onPageActivityChange();
    };

    this.handleWindowFocus = () => {
      this.isWindowFocused = true;
      this.onPageActivityChange();
    };

    this.handleWindowBlur = () => {
      this.isWindowFocused = false;
      this.onPageActivityChange();
    };

    document.addEventListener('visibilitychange', this.handleVisibilityChange);
    window.addEventListener('focus', this.handleWindowFocus);
    window.addEventListener('blur', this.handleWindowBlur);

    // Initialize state
    this.isTabVisible = document.visibilityState === 'visible';
    this.isWindowFocused = document.hasFocus();
  },
  beforeDestroy() {
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    window.removeEventListener('focus', this.handleWindowFocus);
    window.removeEventListener('blur', this.handleWindowBlur);
  },
  methods: {
    /**
     * Called whenever visibility or focus changes.
     * You can override this in your component.
     */
    onPageActivityChange() {
      // Example: auto-refresh only when fully active
      if (this.isPageActive) {
        // Page is active, resume refresh/polling
      } else {
        // Page is inactive, pause background activity
      }
      
    }
  }
};
